<template>
  <a-tooltip :title="label">
    <a v-if="href" class="storefront-shortcut" :href="href" target="_blank" rel="noopener noreferrer" :aria-label="label" :title="label">
      <img v-if="logo && !imageFailed" :key="logo" :src="logo" :alt="platform?'蓝迪云黑白LOGO':'当前店铺LOGO'" @error="onLogoError" />
      <span v-else>{{String(summary?.orgShortName || summary?.orgName || '店').slice(0,1)}}</span>
    </a>
    <button v-else class="storefront-shortcut storefront-retry" type="button" :disabled="loading" :aria-label="label" @click="load">店</button>
  </a-tooltip>
</template>
<script setup lang="ts">
import {computed,ref,watch,onBeforeUnmount} from 'vue'
import store from '@/store'
import api from '@/api/sys'
import platformLogo from '@/assets/images/logo-dark.png'
import {storefrontHref,storefrontLogo} from '@/utils/storefrontShortcut'
const summary=ref<any>(null),loading=ref(false),imageFailed=ref(false)
const orgId=computed(()=>Number(store.getters.userInfo?.orgId)),platform=computed(()=>orgId.value===1000)
const identity=computed(()=>[store.getters.token,store.getters.userInfo?.id,orgId.value].join(':'))
const href=computed(()=>storefrontHref(String(process.env.VUE_APP_CLIENT_URL || ''),orgId.value,summary.value))
// 机构设置中logoUrl是白色LOGO，logoUrl1是黑色LOGO；浅色顶部与客户端导航使用同一黑色优先规则。
const logo=computed(()=>{
  if(platform.value)return platformLogo
  const host=String(store.getters.settings?.imgurl?.value || '')
  return storefrontLogo(summary.value?.logoUrl1,host) || storefrontLogo(summary.value?.logoUrl,host)
})
const label=computed(()=>platform.value?'打开蓝迪云首页':href.value?'打开本店客户端 · '+String(summary.value?.orgShortName || summary.value?.orgName || ''):loading.value?'正在读取本店入口':'本店入口未就绪，点击重试')
let generation=0
async function load(){
  const run=++generation,who=identity.value,id=orgId.value
  summary.value=null;imageFailed.value=false
  if(platform.value || !store.getters.token || !Number.isSafeInteger(id) || id<=1000){loading.value=false;return}
  loading.value=true
  try{const response=await api.getOrgInfo(id);if(run===generation && who===identity.value && Number(response.data?.id)===id)summary.value=response.data}
  catch{/* 不猜测店铺，不退回平台或其他分店。 */}
  finally{if(run===generation)loading.value=false}
}
watch(identity,load,{immediate:true})
watch(logo,()=>{imageFailed.value=false})
function onLogoError(event:Event){
  if((event.currentTarget as HTMLImageElement | null)?.getAttribute('src')===logo.value)imageFailed.value=true
}
onBeforeUnmount(()=>{generation++})
</script>
<style scoped>
.storefront-shortcut{display:inline-flex;align-items:center;justify-content:center;box-sizing:border-box;width:36px;height:36px;padding:2px;margin:0;vertical-align:middle;text-decoration:none;color:inherit;border-radius:50%;overflow:hidden;flex-shrink:0}
.storefront-shortcut img{display:block;width:100%;height:100%;object-fit:contain}
.storefront-shortcut:focus-visible{outline:2px solid currentColor;outline-offset:3px}
.storefront-retry{border:0;background:transparent;cursor:pointer}
</style>
